import Glide from '@glidejs/glide';

class Carousel {
  constructor(props) {
    this.elements = props.elements;
    this.startPoint = props.startPoint;
    this.settings = {
      type: "carousel",
      startAt: this.startPoint || 0,
      perView: 4,
      autoplay: false,
      hoverpause: true,
      keyboard: true,
      swipeThreshold: 80,
      dragThreshold: 120,
      gap: 40,
      breakpoints: {
        1023: {
          gap: 20,
          perView: 3
        },
        567: {
          gap: 20,
          perView: 1,
          peek: {
            before: 0,
            after: 50
          }
        }
      }
    };

    this.initializeCarousel(this.elements, this.settings);
  }

  getViewTypeSettings = viewType => {
    switch (viewType) {
      case "moment":
        return {
          gap: 80,

          breakpoints: {
            1600: {
              gap: 40,
            },
            1024: {
              gap: 20,
            },
            567: {
              gap: 40,
              perView: 1,
              peek: {
                before: 0,
                after: 60,
              },
            }
          }
        }
      case "standard":
        return {
          gap: 40,
        }
      case "single":
        return {
          gap: 40,
          breakpoints: {
            1023: {
              gap: 20,
              perView: 1,
              peek: {
                before: 0,
                after: 0
              },
            },
            567: {
              perView: 1,
              peek: {
                before: 0,
                after: 0,
              },
            }
          }
        }
      case "image":
        return {
          gap: 90,
          breakpoints: {
            1023: {
              gap: 20,
              perView: 3,
              peek: {
                before: 0,
                after: 0
              },
            },
            567: {
              perView: 1,
              peek: {
                before: 0,
                after: 0,
              },
            }
          }
        }
      case "card":
        return {
          gap: 80,
          peek: {
            before: 40,
            after: 40
          },
          breakpoints: {
            1023: {
              gap: 20,
              perView: 3,
              peek: {
                before: 40,
                after: 40
              },
            },
            567: {
              gap: 30,
              perView: 1,
              peek: {
                before: 20,
                after: 60,
              },
            }
          }
        }
    }
  }

  initializeCarousel = (elements, defaultSettings) => {
    if (!(elements && elements.length)) {
      return;
    }

    for (const element of elements) {
      let config;
      const viewType = this.getViewTypeSettings(element.dataset.viewtype || "standard");
      const perView = parseInt(element.dataset.slides) || 3;
      const totalCount = element.dataset.count;
      config = { ...defaultSettings, perView, ...viewType };

      if (element.closest('*[data-overlay="true"]')) {
        const carouselSlides = element.querySelector('ul.glide__slides');
        const pagination = element.querySelector('.d3-o-carousel__pagination');

        if (!(carouselSlides && carouselSlides.children.length)) {
          return;
        }

        for (const slide of carouselSlides.children) {
          const captionToggle = slide.querySelector('.d3-o-media-object__info-overlay');
          const caption = slide.querySelector('.d3-o-media-object__info-content');

          if (caption) {

            const closeButton = caption.querySelector('.d3-o-button__close');
            caption.style.display = 'none';
            captionToggle
              && captionToggle.addEventListener('click', () => {
                captionToggle.style.display = 'none';
                caption.style.display = 'block';
              });

            closeButton
              && closeButton.addEventListener('click', () => {
                captionToggle.style.display = 'flex';
                caption.style.display = 'none';
              });
          }
        }

        const glide = new Glide(element, config)

        if (pagination) {
          glide.on(['mount.after', 'run'], function () {
            pagination.innerHTML = `${glide.index + 1} / ${totalCount}`;
          });
        }

        glide.mount();
      }
      else {
        const glide = new Glide(element, config).mount();
      }
    }
  };
}

export default Carousel
